(()=>{
  let SECOND_MILLIS = 1000, MINUTE_MILLIS = 60*SECOND_MILLIS, HOUR_MILLIS = 60*MINUTE_MILLIS, DAY_MILLIS = 24*HOUR_MILLIS;
  let getSwiperLib = ()=>{
    return window.Swiper;
  };
  let padNumHead = (n, data) => {
    let s = data + "", pre = "";
    if(n > s.length) {
      for(let i=0;i<n-s.length;i++){
        pre += "0";
      }
    }
    return pre + s;
  };
  let getNow = (callback)=>{
    callback.call(null, new Date().getTime());
  };
  let getNow2 = (callback)=>{
    fetch('https://now.fastgrowth.app/').then(response => {
      if (!response.ok)
        throw new Error(`HTTP Error, status = ${response.status}`);
      return response.text();
    }).then(timeText => {
      let obj = JSON.parse(timeText);
      if(obj && obj.status == "success" && obj.code == "200") {
        callback.call(null, obj.data.now_time * SECOND_MILLIS);
      }
    }).catch(error => {
      console.error('get time error, please retry again later:', error);
    });
  };
  let parseDateTime = (str)=>{
    if(!str || str.length < 8) return null;
    const [datePart, timePart] = str.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    if(!year || !month || !day) return null;
    const [hours, minutes, seconds] = (timePart || '00:00:00').split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes, seconds);
  };
  let waitObject = (callback, getter, flag, name)=>{
/*    if(!flag) {
      console.log("Try to locate `"+name+"`...");
    } else {
      console.log("Retry to locate `"+name+"`...");
    }*/
    let btn = getter();
    if(!btn) {
      if(window.tick_20250510180524) {
        clearTimeout(window.tick_20250415123026);
      }
      window.tick_20250510180524 = setTimeout(()=>{
        waitObject(callback, getter, true, name);
      }, 100);
    } else {
      // console.log("Locate `"+name+"` successfully.");
      callback.call();
    }
  };
  let getMySwiper = () => {
    return document.querySelector(".announcement-bar .announcement-carousel-container .ac-swiper-container");
  };
  let loadSwiper = ()=>{
    let tout = document.querySelector(".switch_timeout").value;
    if(!tout) tout = 3000;
    else tout = parseInt(tout);
    var swiper = new Swiper(getMySwiper(), {
      navigation: {
        nextEl: ".announcement-bar .swiper-button-next",
        prevEl: ".announcement-bar .swiper-button-prev",
      },
      loop: true,
      autoplay: {
        delay: tout,
        disableOnInteraction: false,
      },
    });
    //console.log("annoucement loaded.");
  };
  let enableAutoUpdate = ()=>{
    if(window.the_1s_Tick && window.the_1s_Stack){
      let days = document.querySelector(".announcement-carousel-container .d-inline-block.small#countdown_days_num_1"),
      hours = document.querySelector(".announcement-carousel-container .d-inline-block.small#countdown_hours_num_1"),
      minutes = document.querySelector(".announcement-carousel-container .d-inline-block.small#countdown_minutes_num_1"),
      seconds = document.querySelector(".announcement-carousel-container .d-inline-block.small#countdown_seconds_num_1"),
      target_dt = document.querySelector(".announcement-carousel-container #target_countdown_datetime");
      window.the_1s_Stack.push(()=>{
        if(!target_dt) return;
        let target_tick = target_dt.value;
        if(!target_tick || target_tick.length == 0 || !(/^\d+$/.test(target_tick))) return;
        let theTime = parseInt(target_tick) * SECOND_MILLIS;
        getNow2((nowTime)=>{
          if(nowTime >= theTime) return;
          let differ = theTime - nowTime;
          let daysVal = parseInt(differ/DAY_MILLIS);
          let differ1 = differ - daysVal * DAY_MILLIS;
          let hoursVal = parseInt(differ1/HOUR_MILLIS);
          let differ2 = differ1 - hoursVal * HOUR_MILLIS;
          let minutesVal = parseInt(differ2/MINUTE_MILLIS);
          let differ3 = differ2 - minutesVal * MINUTE_MILLIS;
          let secondsVal = parseInt(differ3/SECOND_MILLIS);
          //console.info("differ="+differ+", hours="+hoursVal+", minutes="+minutesVal+", seconds="+secondsVal);
          days.innerHTML = padNumHead(2,daysVal);
          hours.innerHTML = padNumHead(2,hoursVal);
          minutes.innerHTML = padNumHead(2,minutesVal);
          seconds.innerHTML = padNumHead(2,secondsVal);
        });
      });
    } else {
      window.allow_the_1s_tick_run = true, window.stop_the_1s_tick_immediately = false;
      window.the_1s_Stack = [];
      window.the_1s_Tick = setInterval(()=>{
        if(window.allow_the_1s_tick_run && window.the_1s_Stack.length > 0){
          window.the_1s_Stack.forEach((fn)=>{
            if(typeof fn != "function") return;
            fn.call();
          });
        }
        if(window.stop_the_1s_tick_immediately){
          if(window.the_1s_Tick) clearInterval(window.the_1s_Tick);
        }
      }, 1000);
      enableAutoUpdate();
    }
  };

/* WCAG - Eliminate duplicate element IDs */
const appendIdSuffixSafe = function(parentSelector, suffix = "_ok") {
  const parent = document.querySelector(parentSelector);
  if (!parent) return;
  const allHasIdEls = parent.querySelectorAll('[id]');
  const suffixReg = new RegExp(`${suffix}$`);
  allHasIdEls.forEach(el => {
    let oldId = el.id;
    if (suffixReg.test(oldId)) { oldId = oldId.replace(suffixReg, ''); }
    el.id = oldId + suffix;
  });
};

  document.addEventListener('DOMContentLoaded', ()=>{
    waitObject(loadSwiper, getSwiperLib, false, "SwiperJS");
    enableAutoUpdate();
    window.$parseDateTime = parseDateTime;
    appendIdSuffixSafe('.as-announcement-contents.announcement-carousel-container.ac-v1', '_ok');
    appendIdSuffixSafe('.as-announcement-contents.announcement-carousel-container.ac-v2', '_ok');
  });
})()